import {svgIconWrapper} from '../svg-icon-wrapper';

import WebflowRegular from './webflow-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <WebflowRegular {...rest} />;
}

SvgComponent.iconName = 'webflowRegular';

export const WebflowRegularIcon = svgIconWrapper(SvgComponent);
